import * as React from "react";
import * as PropTypes from "prop-types";
import get from "lodash.get";

import { FieldWrapper } from "./Field.styles";
import FormField from "components/FormField/FormField";
import UISearchDropdown from "components/UI/SearchDropdown";
import { validValuesToItems } from "utils/mapping";
import { maxDateSymbol, minDateSymbol } from "utils/dates";
import AddressField from "./AddressField";

class WorkItemFormField extends React.Component {
  state = {
    selectedItem: null,
    items: null
  };

  constructor(props) {
    super(props);

    const { item } = props;

    if (item.type !== "List") return;

    if (typeof item.validValues !== "object") {
      this.state = { value: item.value, items: item.validValues };
      return;
    }

    const items = validValuesToItems(item.validValues, "|");
    const selectedItem = items.find(x => x.value === item.value) || items[0];
    this.state = { items, selectedItem };
  }

  handleChange = value => {
    const { item } = this.props;
    this.props.onChange(item.key, get(value, "value", value), item);
  };

  handleDropdownSelection = selectedItem => {
    this.setState({ selectedItem });
    this.handleChange(selectedItem);
  };

  render() {
    const {
      onChange: _,
      item: propItem,
      readOnly,
      features,
      ...otherProps
    } = this.props;

    if(this.props.item.type == "List"){
      this.state.items = validValuesToItems(this.props.item.validValues, "|");
      this.state.selectedItem = this.state.items.find(x => x.value === this.props.item.value) || this.state.items[0];
    }

    const { items, selectedItem } = this.state;

    const hasAddressAutocompletion = features.some(
      x => x.name === "AddressAutocompletion" && x.value === true
    );

      if (hasAddressAutocompletion && (propItem.key === "cAddress" || propItem.key === "cACVAddress")) {
      return (
        <FieldWrapper {...otherProps}>
          <AddressField
            id ={this.props.item.key}
            stateName={this.props.stateName}
            title={propItem.name}
            placeholder={propItem.helpText}
            value={propItem.value}
            maxLength={propItem.maxLength}
            onChange={this.handleChange}            
            onAddressComponentChange={this.props.onChange}
            isRequired={Boolean(propItem.required === "True")}  
            veReport={Boolean(propItem.veReport === "true")}
            processNumber={Boolean(propItem.processNumber ? true : false)}           
          />
        </FieldWrapper>
      );
    }
    switch (propItem.type) {
      case "List":
        return (
          <FieldWrapper {...otherProps}>
            <UISearchDropdown
              id ={this.props.item.key}
              value={selectedItem}
              items={items}
              label={propItem.name}
              readOnly={readOnly}
              required={Boolean(propItem.required === "True")}
              onSelection={this.handleDropdownSelection}
              disabled={Boolean(propItem.disabled === "true")}
            />
          </FieldWrapper>
        );
      case "VIN":
        return (
          <FieldWrapper {...otherProps}>
            <FormField
              id ={this.props.item.key}
              onChange={this.handleChange}
              fieldType="VIN"
              title={propItem.name}
              placeholder={propItem.helpText}
              value={propItem.value}
              isRequired={Boolean(propItem.required === "True")}
              disabled={Boolean(propItem.disabled === "true")}
            />
          </FieldWrapper>
        );
      case "Date":
        return (
          <FieldWrapper {...otherProps}>
            <FormField
              id ={this.props.item.key}
              fieldType="DatePicker"
              title={propItem.name}
              placeholder={propItem.helpText}
              value={propItem.value}
              isRequired={Boolean(propItem.required === "True")}
              onChange={this.handleChange}
              maxDate={propItem[maxDateSymbol]}
              minDate={propItem[minDateSymbol]}
              disabled={Boolean(propItem.disabled === "true")}
            />
          </FieldWrapper>
        );
      case "Number":
        return (
          <FieldWrapper {...otherProps}>
            <FormField
              id ={this.props.item.key}
              onChange={this.handleChange}
              fieldType="Number"
              title={propItem.name}
              placeholder={propItem.helpText}
              value={propItem.value}
              isRequired={Boolean(propItem.required === "True")}
              disabled={Boolean(propItem.disabled === "true")}
            />
          </FieldWrapper>
        );
      case "Currency":
        return (
          <FieldWrapper {...otherProps}>
            <FormField
              id ={this.props.item.key}
              onChange={this.handleChange}
              fieldType="Currency"
              title={propItem.name}
              placeholder={propItem.helpText}
              value={parseFloat(propItem.value)}
              isRequired={Boolean(propItem.required === "True")}
              disabled={Boolean(propItem.disabled === "true")}
            />
          </FieldWrapper>
        );
      case "Phantom":
        return null;
      default:
        return (
          <FieldWrapper {...otherProps}>
            <FormField
              id ={this.props.item.key}
              fieldType="Text"
              title={propItem.name}
              placeholder={propItem.helpText}
              value={propItem.value}
              maxLength={propItem.maxLength}
              mask={propItem.mask}
              onChange={this.handleChange}
              isRequired={Boolean(propItem.required === "True")}
              disabled={Boolean(propItem.veReport === "true") && Boolean(propItem.processNumber === "true")}
            />
          </FieldWrapper>
        );
    }
  }
}

WorkItemFormField.propTypes = {
  item: PropTypes.object.isRequired,
  onChange: PropTypes.func
};

export default WorkItemFormField;
